
import { useAuth } from '@/context/AuthContext';
import ProfileDropdown from '../ProfileDropdown';
import { RentalPointSwitcher } from '../RentalPointSwitcher';
import GlobalSearch from '@/components/search/GlobalSearch';
import { HeaderActions } from './HeaderActions';

export const DesktopHeader = () => {
  const { isAuthenticated } = useAuth();

  return (
    <div className="hidden desktop:flex desktop:items-center desktop:justify-between desktop:w-full">
      <div className="flex items-center space-x-4">
        {isAuthenticated && (
          <GlobalSearch 
            className="flex-1 max-w-md" 
            placeholder="Поиск по всем данным..."
          />
        )}
      </div>
      
      <div className="flex items-center space-x-3">
        {isAuthenticated && (
          <>
            <HeaderActions />
            <RentalPointSwitcher />
            <ProfileDropdown />
          </>
        )}
      </div>
    </div>
  );
};
